import BlogDetailsComponent from '../components/blog-detail/blogDetail'

const BlogDetails = () => <BlogDetailsComponent />

export default BlogDetails;